export default __webpack_public_path__ + "static/media/Kalos.61abe03b.jpg";